import { render } from "./ProductTable.vue?vue&type=template&id=3117a173&scoped=true"
import script from "./ProductTable.vue?vue&type=script&lang=js"
export * from "./ProductTable.vue?vue&type=script&lang=js"

import "./ProductTable.vue?vue&type=style&index=0&id=3117a173&scoped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3117a173"]])

export default __exports__